// D-291b — pure helpers of the in-place time edit (InlineTimeRange): what is sent on a save and on
// "shorten" after the server refused with a structured overlap (WORK_LOG_OVERLAP). No React.
import { overlapConflictOf, type OverlapConflict } from './overlapModel';

export type InlineWhich = 'start' | 'end';

/** The PATCH body of one edited time. */
export const inlineTimePayload = (which: InlineWhich, iso: string): { start_time?: string; end_time?: string } =>
  (which === 'start' ? { start_time: iso } : { end_time: iso });

/** A structured overlap refusal, or null (any other error keeps the plain inline message). */
export const inlineOverlapOf = (err: unknown): OverlapConflict | null => overlapConflictOf(err);

/**
 * "Shorten": only an END edit can be shortened (the start stays, the end becomes the suggested one);
 * for a START edit the server's suggestion does not apply -> null (no shorten button).
 */
export function inlineShortenPayload(which: InlineWhich, c: OverlapConflict): { end_time: string } | null {
  if (which !== 'end' || !c.suggestedEnd) return null;
  return { end_time: c.suggestedEnd };
}
